<template>
  <Component
    :is="as"
    class="list-value text-sm first:text-muted last:font-medium last:text-emphasis"
  >
    <slot />
  </Component>
</template>
<script lang="ts" setup>
const { as = "p" } = defineProps<{ as?: string }>();
</script>
